import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { ApiConfig } from '../../../core/api.service';
import { Observable } from 'rxjs';
import { AccountSaveResult } from '../../../core/account-management/account-save-result';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountCreationService {

    constructor(private http: HttpClient) { }
    private apiConfigInstance = ApiConfig.getInstance();   

    sendValidationCode(validationCode: string, phoneNumber: string, systemId: number, applicationId: number): Observable<any> {
        var apiUrl = '/api/texting/sendValidationCode';
        return this.apiConfigInstance.postData(this.http, apiUrl, JSON.stringify({ information: validationCode, phoneNumber: phoneNumber, systemId: systemId, applicationId: applicationId }));
    }

    createAccount(formValues: any): Observable<AccountSaveResult> {   
        var apiUrl = '/webapi/api/accountcreationtransitions/creatementoruser/';  
        return this.keyValueResultToAccountSaveResult(this.apiConfigInstance.postData(this.http, apiUrl, formValues));
    }

    updateAccount(formValues: any): Observable<AccountSaveResult> {
        var apiUrl = '/webapi/api/accountcreationtransitions/updatementoruser/';
        return this.keyValueResultToAccountSaveResult(this.apiConfigInstance.postData(this.http, apiUrl, formValues));
    }


    getExistingUser(userid: string, pwd: string, apiToken: string) {
        this.apiConfigInstance.setApiToken(apiToken);
        var apiUrl = '/api/core/user/getExistingUser'
        var data = {
            username: userid,
            password: pwd
        }
        return this.apiConfigInstance.postData(this.http, apiUrl, data);
    }

    GetSchoolInfo(resourid: string) {
        var apiUrl = '/api/core/user/GetSchoolInfo/' + resourid
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    GetSchoolInfoByResourceId(resourceId: string) {
        var apiUrl = '/webapi/api/user/GetSchoolInfoByResourceId?resourceId=' + resourceId
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    // moved
    doesUserNameExist(accountName: string) {       
        var apiUrl = '/webapi/api/accountcreationtransitions/DoesUsernameExist/' + accountName + '/';
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    // moved
    doesEmailExist(email: string) {
        var apiUrl = '/webapi/api/accountcreationtransitions/DoesEmailExist/' + email + '/';
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    //moved
    getSchoolList() {
        var sessionVariables = this.apiConfigInstance.getSession();        

        var systemId = sessionVariables.systemInfo.currentSystemId;    
        var siteTypeId = sessionVariables.systemInfo.currentSiteTypeId;

        var apiUrl = '/webapi/api/accountcreationtransitions/GetSchoolList?systemId=' + systemId + '&siteTypeId=' + siteTypeId;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    getSchoolListUpdated(selectedRoleValue: number) {
        var sessionVariables = this.apiConfigInstance.getSession();

        var systemId = sessionVariables.systemInfo.currentSystemId;
        var siteTypeId = sessionVariables.systemInfo.currentSiteTypeId;

        var apiUrl = '/webapi/api/accountcreationtransitions/GetSchoolList?systemId=' + systemId + '&siteTypeId=' + siteTypeId + '&selectedRole=' + selectedRoleValue;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    getDistrictSchoolList(districtId: number) {
        var sessionVariables = this.apiConfigInstance.getSession();

        var systemId = sessionVariables.systemInfo.currentSystemId;
        var siteTypeId = sessionVariables.systemInfo.currentSiteTypeId;

        var apiUrl = '/webapi/api/accountcreationtransitions/GetDistrictSchoolList?systemId=' + systemId + '&siteTypeId=' + siteTypeId + '&districtId=' + districtId;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    getSystemCreateAccountConfigItem(key: string) {
        var sessionVariables = this.apiConfigInstance.getSession();

        var systemId = sessionVariables.systemInfo.currentSystemId;
        var apiUrl = '/webapi/api/accountcreationtransitions/GetSystemCreateAccountConfigItem?key=' + key + '&systemId=' + systemId;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    //moved
    setActivationCode(code: string) {
        var codeToAdd = (code) ? code : "-1";
        var apiUrl = '/webapi/api/accountcreationtransitions/SetActivationCode/' + codeToAdd;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    SetGroupID(groupid: string) {
        var apiUrl = '/webapi/api/accountcreationtransitions/SetGroupID/' + groupid;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }
    // moved
    setResourceId(id: string) {
       // var idToAdd = (code) ? code : "-1";
        var apiUrl = '/webapi/api/accountcreationtransitions/SetResourceId/' + id;
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    // moved
    getConfigList(applicationId: number) {
        var sessionVariables = this.apiConfigInstance.getSession();
        var systemId = sessionVariables.systemInfo.currentSystemId; 
        var domainId = sessionVariables.systemInfo.currentDomainId; 
        var resourceId = sessionVariables.systemInfo.currentResourceId; 

        //TODO: wire group up        
        var groupId = -1;

        var apiUrl = '/webapi/api/accountcreationtransitions/GetCreateAccountConfigList?applicationId=' + applicationId + '&resourceId=' + resourceId + '&groupId=' + groupId + '&systemId=' + systemId + '&domainId=' + domainId;

        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    //moved
    getEmailSettings(applicationId: number) {
        var sessionVariables = this.apiConfigInstance.getSession();
        var systemId = sessionVariables.systemInfo.currentSystemId; 

        var apiUrl = '/webapi/api/accountcreationtransitions/GetEmailSettings?applicationId=' + applicationId + '&systemIdParam=' + systemId;

        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    setActivationDistrictSchool(userId: string, schoolId: number): Observable<any> {
        var apiUrl = '/webapi/api/accountcreationtransitions/ActivationChangeDistrictSchool';
        return this.apiConfigInstance.postData(this.http, apiUrl, JSON.stringify({ userId: userId, schoolId: schoolId }));
    }    

    private keyValueResultToAccountSaveResult(kvr: Observable<any>): Observable<AccountSaveResult> {
        return kvr.pipe(map((result) => {
            let asr = new AccountSaveResult();
            asr.success = result.Key;
            if (asr.success) {
                asr.successMsg = result.Value;
            } else {
                asr.errorMsg = result.Value;
                asr.errorField = result.Resource;
            }
            if (result.Resource) {
                asr.accountCreationToken = result.Resource;
            }
            return asr;
        }));
    }

    triggerValidation() {

        this.apiConfigInstance.triggerValidation();
    }

    scrollToFirstError() {
        setTimeout(function () {
            var errorElement = document.querySelector('.has-error');
            if (errorElement) {
                //errorElement.scrollIntoView(errorElement);               
                errorElement.scrollIntoView();
            }
        }, 100);
    }
}
